import { MouseEvent } from 'react';

interface IOptions {
	setMenuAnchorEl: CallableFunction;
	setSelectedSort: CallableFunction;
	setSelectedTechPacks: CallableFunction | undefined;
}

const genHandleSortClearClick = ({
	setMenuAnchorEl,
	setSelectedSort,
	setSelectedTechPacks,
}: IOptions) => {
	return (event: MouseEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();

		setSelectedSort('');
		setMenuAnchorEl(null);
		setSelectedTechPacks && setSelectedTechPacks([]);
	};
};

export default genHandleSortClearClick;
